import TButton from './button.vue'
import TButtonGroup from './button-group.vue'
TButton.Group = TButtonGroup
export default TButton



// WEBPACK FOOTER //
// ./src/components/button/index.js